<template>
  <div class="block">
    <div class="block-content block-content-full">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-12">
              <div class="form-group search-info">
                <input v-model="query" type="text" name="search" class="form-control form-control-alt search-main"
                  placeholder="Enter keywords here">
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <div class="form-group search-info">
                <label style="font-size:12px">Name</label>
                <input v-model="searchName" type="text" name="name-search"
                  class="form-control form-control-alt search-main" placeholder="Enter name here">
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <div class="form-group search-info">
                <label style="font-size:12px">Email</label>
                <input v-model="searchEmail" type="email" name="email-search"
                  class="form-control form-control-alt search-main" placeholder="Enter email here">
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <div class="form-inline">
                <div class="input-group dashboardcode-bsmultiselect w-100">
                  <label style="font-size:12px">Company</label>
                  <company-name-select ref="companyNameSelect" v-model="companyNameQuery"
                    @update-filter="updateCompanyFilters" />
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <div class="form-inline">
                <div class="input-group dashboardcode-bsmultiselect w-100">
                  <label style="font-size:12px">Job Title</label>
                  <job-title-select ref="jobTitleSelectRef" v-model="jobTitleQuery"
                    @update-filter="updateJobTitleFilters" />
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <div class="form-inline">
                <div class="input-group dashboardcode-bsmultiselect w-100">
                  <label style="font-size:12px">Country</label>
                  <multiselect v-model="countriesSelected" placeholder="Search for Country" label="nice_name"
                    track-by="nice_name" :options="countries" :multiple="true" :taggable="false" @input="runQuery" />
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <div class="form-inline">
                <div class="input-group dashboardcode-bsmultiselect w-100">
                  <label style="font-size:12px">Industry</label>
                  <multiselect v-model="industriesSelected" placeholder="Search for Industry" label="industry_name"
                    track-by="industry_name" :options="industries" :multiple="true" :taggable="false"
                    @input="runQuery" />
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <div class="form-inline">
                <div class="input-group dashboardcode-bsmultiselect w-100">
                  <label style="font-size:12px">Payment Status</label>
                  <assignment-status-select v-model="payStatusFilters" :status-list="payStatuses" />
                </div>
              </div>
            </div>
          </div>
          <hr>
        </div>
        <div class="col-md-6">
          <div class="row mb-3">
            <div id="requirements" class="col-12">
              <h5 class="mb-1">
                Requirements
              </h5>

              <div v-for="requirement in requirements" :key="requirement.id"
                class="custom-control custom-checkbox custom-control-lg mb-1">
                <input :id="requirement['id']" v-model="requirementsSelected" type="checkbox"
                  class="custom-control-input" :value="requirement.id" @change="runQuery">
                <label class="custom-control-label" :for="requirement['id']">{{ requirement["label"] }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h5 class="mb-1">
                Display options
              </h5>

              <div v-for="displayOption in displayOptions" :key="displayOption.id"
                class="custom-control custom-checkbox custom-control-lg mb-1 display-option">
                <input :id="displayOption['id']" type="checkbox" class="custom-control-input"
                  :value="displayOption['id']" @click="setDisplayOptions(displayOption['id'], $event)">
                <label class="custom-control-label" :for="displayOption['id']">{{ displayOption["label"] }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- create search button -->
        <div class="col-12">
          <button type="button" class="btn btn-sm btn-primary" @click="$emit('search')">
            <b-spinner v-if="loading" type="border" small label="Fetching Experts" variant="info" />
            Search
          </button>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div id="clientSearchInfoContainer" role="alert" class="alert alert-success d-flex align-items-center">
              <div class="flex-00-auto">
                <i id="clientSearchInfoSymbol" class="fa fa-fw fa-check" />
              </div>
              <div class="flex-fill ms-3">
                <p id="clientSearchInfo" class="mb-0">
                  {{ Number(total) > 0 ? "Loaded" : "Found" }} {{ total }} experts
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { difference, unescape } from "lodash";

export default {
  name: "ExpertSearchBar",
  components: { Multiselect },
  props: {
    targetCompanies: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    relevantJobs: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    countries: {
      type: Array,
      required: true,
    },
    industries: {
      type: Array,
      required: true,
    },
    payStatuses: {
      type: Array,
      required: true,
    },
    total: {
      type: [Number, String],
      required: false,
      default() {
        return 0;
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      countriesSelected: [],
      industriesSelected: [],
      requirementsSelected: [],
      q: "",
      searchEmail: "",
      searchName: "",
      companyNameQuery: "",
      companyTags: [],
      companyFilters: [],
      jobTitleQuery: "",
      jobTitleFilters: [],
      jobTitleTags: [],
      payStatusFilters: [],
      requirements: [
        {
          id: "requireEmail",
          label: "Has email",
        },
        {
          id: "requireTerms",
          label: "Has signed terms",
        },
        {
          id: "requireMobileNumber",
          label: "Has mobile number",
        },
        {
          id: "requireBusinessNumber",
          label: "Has business number",
        },
      ],
      displayOptions: [
        {
          id: "hideJobExperiences",
          label: "Hide job experiences",
        },
      ],
    };
  },
  computed: {
    query: {
      get() {
        return this.q;
      },
      set(q) {
        this.q = q;
      },
    },
    mergedCompanies() {
      return Array.from(new Set([...this.companyTags, ...this.companyFilters]));
    },
    mergedJobs() {
      return Array.from(new Set([...this.jobTitleTags, ...this.jobTitleFilters]));
    },
  },
  watch: {
    query(nv, ov) {
      this.triggerQuery(nv, ov);
    },
    searchEmail(nv, ov) {
      this.triggerQuery(nv, ov);
    },
    searchName(nv, ov) {
      this.triggerQuery(nv, ov);
    },
    companyFilters() {
      this.runQuery();
    },
    jobTitleFilters() {
      this.runQuery();
    },
    payStatusFilters() {
      this.runQuery();
    },
    jobTitleQuery(nv, ov) {
      this.triggerQuery(nv, ov);
      this.jobTitleTags = this.$refs.jobTitleSelectRef.getSelectedTags();
    },
    companyNameQuery: {
      handler(nv, ov) {
        this.triggerQuery(nv, ov);
        this.companyTags = this.$refs.companyNameSelect.getSelectedTags()
      }
    },
    targetCompanies: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          /*const companies = newValue.join(", ");
          console.log('companies updated via watcher', companies);
          this.companyNameQuery = companies;*/

          // Add each target company as a tag to the company-name-select component on load
          newValue.forEach(company => {
            const companyName = unescape(company);
            const companySelect = this.$refs.companyNameSelect;
            if (companySelect) {
              companySelect.addTag(companyName);
            }
          });
        }
      },
      immediate: true
    },
    relevantJobs: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          newValue.forEach(job => {
            const jobTitle = unescape(job);
            const jobTitleRef = this.$refs.jobTitleSelectRef;
            if (jobTitleRef) {
              jobTitleRef.addTag(jobTitle);
            }
          });
        }
      },
      immediate: true
    },
  },
  methods: {
    triggerQuery(nv, ov) {
      if (nv.length >= 2 || (ov.length > nv.length && nv.length === 0)) {
        this.debounceInput();
      }
    },
    debounceInput: _.debounce(function () {
      this.runQuery();
    }, 300),
    prepareQueryString() {
      let query = "";
      if (this.q.length >= 2) {
        query += `q=${encodeURIComponent(this.q)}`;
      }

      if (this.searchEmail.length >= 2) {
        if (query.length > 0) {
          query += `&`;
        }
        query += `email=${this.searchEmail}`;
      }

      if (this.searchName.length >= 2) {
        if (query.length > 0) {
          query += `&`;
        }
        query += `name=${encodeURIComponent(this.searchName)}`;
      }

      const filteredJobTags = this.processTags(this.relevantJobs, this.jobTitleTags);
      const newJobTagsString = filteredJobTags.join(" ");
      if (filteredJobTags.length >= 0) {
        if (query.length > 0) {
          query += `&`;
        }
        query += `job-title-query=${encodeURIComponent(newJobTagsString)}`;
      }

      /*if (this.jobTitleQuery.length >= 2) {
        if (query.length > 0) {
          query += `&`;
        }
        query += `job-title=${encodeURIComponent(this.jobTitleQuery)}`;
      }*/

      const filteredTags = this.processTags(this.targetCompanies, this.companyTags);
      const newTagsString = filteredTags.join(" ");
      if (filteredTags.length >= 0) {
        if (query.length > 0) {
          query += `&`;
        }
        query += `company-query=${encodeURIComponent(newTagsString)}`;
      }

      if (this.countriesSelected.length > 0) {
        if (query.length > 0) {
          query += `&`;
        }
        query += "countries=[";
        this.countriesSelected.forEach(v => {
          query += `"${encodeURIComponent(v.nice_name)}",`;
        });

        query = query.replace(/,\s*$/, "");
        query += "]";
      }

      const finalCompanies = this.companyFilters;
      if (finalCompanies.length > 0) {
        if (query.length > 0) {
          query += `&`;
        }
        query += "company-filter=[";
        finalCompanies.forEach(company => {
          query += `"${encodeURIComponent(company)}",`;
        });
        query = query.replace(/,\s*$/, "");
        query += "]";
      }

      const finalJobs = this.jobTitleFilters;
      if (finalJobs.length > 0) {
        if (query.length > 0) {
          query += `&`;
        }

        query += "job-filter=[";
        finalJobs.forEach(job => {
          query += `"${encodeURIComponent(job)}",`;
        });

        query = query.replace(/,\s*$/, "");
        query += "]";
      }

      if (this.payStatusFilters.length > 0) {
        if (query.length > 0) {
          query += `&`;
        }
        query += "pay-status=[";
        this.payStatusFilters.forEach(status => {
          query += `"${encodeURIComponent(status)}",`;
        });
        query = query.replace(/,\s*$/, "");
        query += "]";
      }

      if (this.industriesSelected.length > 0) {
        if (query.length > 0) {
          query += `&`;
        }
        query += "industries=[";
        this.industriesSelected.forEach(v => {
          query += `"${encodeURIComponent(parseInt(v.id))}",`;
        });
        query = query.replace(/,\s*$/, "");
        query += "]";
      }

      if (this.requirementsSelected.length > 0) {
        if (query.length > 0) {
          query += `&`;
        }
        query += "requirements=[";
        this.requirementsSelected.forEach(v => {
          query += `"${encodeURIComponent(v)}",`;
        });
        query = query.replace(/,\s*$/, "");
        query += "]";
      }

      if (query.length > 0) {
        query = `&${query}`;
      }
      return query;
    },
    async runQuery() {
      // console.log("runQuery", "runQuery");

      const queryString = this.prepareQueryString();

      /*console.log("queryString", queryString);
      console.log("kw", this.q);*/

      this.$emit("setQuery", queryString);
      this.$emit("setMainKeyword", this.q);

      // Extract all search fields into array for marking
      const searchFields = [
        this.q,
        this.searchName,
        this.searchEmail
      ];

      if (this.mergedCompanies.length) {
        const companies = this.companyFilters;
        searchFields.push(...companies);
      }

      if (this.mergedJobs.length) {
        const jobTitles = this.jobTitleFilters;
        searchFields.push(...jobTitles);
      }

      // Filter out empty strings and trim whitespace
      const markString = searchFields
        .filter(field => field && field.trim().length > 0)
        .map(field => field.trim());

      this.$emit("markString", markString);
    },
    setDisplayOptions(string, e) {
      const status = e.target.checked ? true : false;
      this.$emit("setDisplayOptions", {
        id: string,
        status: status,
      });
    },
    updateCompanyFilters(filters) {
      if (!filters) {
        return;
      }

      this.companyFilters = filters;
    },
    updateJobTitleFilters(filters) {
      if (!filters) {
        return;
      }

      this.jobTitleFilters = filters;
    },
    getFilterArray(filters) {
      return filters.map(company => company);
    },

    /**
     * Process tags to filter out target items
     *
     * @param {Array} targetItems - Array of target items (companies or jobs) to be unescaped and filtered
     * @param {Array} currentTags - Current tags array to check against target items
     * @returns {Array} - Array of new tags that don't exist in targetItems
     * @throws {Error} - If either parameter is not an array
     */
    processTags(targetItems, currentTags) {
      if (!Array.isArray(targetItems) || !Array.isArray(currentTags)) {
        console.error('processTags: Both parameters must be arrays');
        return [];
      }

      try {
        // Unescape each item in the target array
        const unescapedTargets = targetItems.map(item => unescape(item));

        // Find tags that are not in the target array
        return difference(currentTags, unescapedTargets);
      } catch (error) {
        console.error('Error in processTags function:', error);
        return [];
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
